/**
 * OnboardingWizard — запускает интерактивный driver.js тур.
 * Автозапуск при первом входе (localStorage). Повторный — через кнопку «?».
 */
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useTour } from '@/tour/useTour'
import { getDefaultTour } from '@/tour/tourConfig'
import type { Role } from '@/types'

function storageKey(userId: string): string {
  return `tour_v2_done_${userId}`
}

interface Props {
  userId: string
  role: Role
  forceShow?: boolean
  onClose?: () => void
}

export default function OnboardingWizard({ userId, role, forceShow = false, onClose }: Props) {
  const { startTour } = useTour()
  const { pathname } = useLocation()

  useEffect(() => {
    if (forceShow) {
      const tourId = getDefaultTour(role, pathname)
      if (tourId) {
        const t = setTimeout(() => {
          startTour(tourId)
          onClose?.()
        }, 300)
        return () => clearTimeout(t)
      } else {
        onClose?.()
      }
      return
    }

    // Автозапуск при первом входе
    const done = localStorage.getItem(storageKey(userId))
    if (!done) {
      const tourId = getDefaultTour(role, pathname)
      if (tourId) {
        const t = setTimeout(() => {
          startTour(tourId)
          localStorage.setItem(storageKey(userId), '1')
        }, 1200)
        return () => clearTimeout(t)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId, role, forceShow, pathname])

  return null  // driver.js рендерит свой оверлей сам
}
